import clsx from 'clsx'
import BurgurMenu from '../../../assets/media/svg_supplier/burgur-menu.svg'
import Logo from '../../../assets/media/uSupplierLogo.png'
import { useSidebar } from './Sidebar'

const SidebarLogo = () => {
  const { collapsed, toggle, expand } = useSidebar()

  return (
    <div
      className={clsx(
        'app-sidebar-logo flex shrink-0 items-center',
        collapsed ? 'justify-center px-1 py-2' : 'justify-between px-4 py-3'
      )}
      id='kt_app_sidebar_logo'
    >
      {!collapsed && (
        <div className='flex min-w-0 flex-1 items-center overflow-hidden'>
          <div className='max-w-full rounded bg-white px-2 py-1'>
            <img
              alt='Logo'
              src={Logo}
              className='app-sidebar-logo-default block h-auto max-h-9 w-auto max-w-full object-contain'
            />
          </div>
        </div>
      )}
      <button
        type='button'
        id='kt_app_sidebar_toggle'
        onClick={toggle}
        onMouseEnter={() => {
          if (collapsed) expand()
        }}
        className={clsx(
          'app-sidebar-toggle btn btn-flush bg-transparent rotate flex items-center justify-center p-0 border-0',
          { active: collapsed }
        )}
        title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      >
        <img
          src={BurgurMenu}
          className='h-[34px] w-[34px] bg-black rotate-180 d-none d-lg-flex'
          alt=''
        />
      </button>
    </div>
  )
}

export { SidebarLogo }
